import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SALES_AND_COMMISSION_CONSTANTS } from "./SalesAndCommission.constants";
import { useSalesAndCommission } from "./useSalesAndCommission";

const StatCard = ({ label, children, isLoading }) => (
  <div className="tw-bg-[#FAFAFD] tw-border tw-border-solid tw-border-[#EEECF5] tw-rounded-[14px] tw-p-[22px_24px] tw-flex-1">
    <span className="tw-text-xs sm:tw-text-sm tw-font-medium tw-text-slate-400 tw-block tw-mb-2">
      {label}
    </span>
    {isLoading ? (
      <div className="tw-h-8 tw-flex tw-items-center">
        <CircularProgress size={20} className="tw-text-[#4E39DF]" />
      </div>
    ) : (
      <div className="tw-min-h-[32px] tw-flex tw-items-center">{children}</div>
    )}
  </div>
);

export const SalesAndCommission = ({ referralOverview }) => {
  const { TITLE, COMMISSION_LABEL, SALES_LABEL, SEPARATOR } =
    SALES_AND_COMMISSION_CONSTANTS;

  const {
    currencySymbol,
    isLoading,
    commissionValue,
    salesCount,
    totalSalesAmount,
    salesText,
  } = useSalesAndCommission(referralOverview);

  return (
    <section className="tw-w-full tw-my-16">
      <h2 className="tw-text-xl tw-font-bold tw-text-slate-900 tw-m-0 tw-mb-4">
        {TITLE}
      </h2>

      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 sm:tw-gap-6">
        {/* Card 1: Commission till now */}
        <StatCard label={COMMISSION_LABEL} isLoading={isLoading}>
          <span className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-[#4E39DF] tw-tracking-tight">
            {currencySymbol}
            {commissionValue}
          </span>
        </StatCard>

        {/* Card 2: Sales made */}
        <StatCard label={SALES_LABEL} isLoading={isLoading}>
          <div className="tw-flex tw-items-center tw-gap-2 tw-text-xl sm:tw-text-2xl tw-font-extrabold tw-text-slate-900 tw-tracking-tight">
            <span>
              {salesCount} {salesText}
            </span>
            <span className="tw-text-slate-400 tw-font-normal">
              {SEPARATOR}
            </span>
            <span>
              {currencySymbol}
              {totalSalesAmount}
            </span>
          </div>
        </StatCard>
      </div>
    </section>
  );
};
